import { render, staticRenderFns } from "./ActivityDetail.vue?vue&type=template&id=621df2ca&scoped=true&"
import script from "./ActivityDetail.vue?vue&type=script&lang=ts&"
export * from "./ActivityDetail.vue?vue&type=script&lang=ts&"
import style0 from "./ActivityDetail.vue?vue&type=style&index=0&id=621df2ca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621df2ca",
  null
  
)

export default component.exports